import { PlotSeriesOptions } from 'highcharts';
import { z } from 'zod';

export enum POLARS_INTERVALS {
  ONE_DAY = '1d',
  ONE_WEEK = '1w',
  ONE_MONTH = '1mo',
  ONE_QUARTER = '1q',
  ONE_YEAR = '1y',
}

export const PolarsIntervalSchema = z.nativeEnum(POLARS_INTERVALS);

export function polarsIntervalToHighchartsSeriesPlotOptions(
  polarsInterval?: POLARS_INTERVALS
): Pick<PlotSeriesOptions, 'pointIntervalUnit' | 'pointInterval' | 'pointRange'> {
  if (!polarsInterval) {
    return {
      pointIntervalUnit: undefined,
      pointInterval: undefined,
    };
  }
  switch (polarsInterval) {
    case POLARS_INTERVALS.ONE_DAY:
      return {
        pointIntervalUnit: 'day',
        pointInterval: 1,
        pointRange: 1 * 24 * 3600 * 1000, // 1 days in milliseconds
      };
    case POLARS_INTERVALS.ONE_WEEK:
      return {
        pointIntervalUnit: 'day',
        pointInterval: 7,
        pointRange: 7 * 24 * 3600 * 1000, // 7 days in milliseconds
      };
    case POLARS_INTERVALS.ONE_MONTH:
      return {
        pointIntervalUnit: 'month',
        pointInterval: 1,
        pointRange: 30 * 24 * 3600 * 1000, // 30 days in milliseconds
      };
    case POLARS_INTERVALS.ONE_QUARTER:
      return {
        pointIntervalUnit: 'month',
        pointInterval: 3,
        pointRange: 3 * 30 * 24 * 3600 * 1000, // 90 days in milliseconds
      };
    case POLARS_INTERVALS.ONE_YEAR:
      return {
        pointIntervalUnit: 'year',
        pointInterval: 1,
        pointRange: 365 * 24 * 3600 * 1000, // 365 days in milliseconds
      };
    default:
      throw new Error(`Unknown interval ${String(polarsInterval)}`);
  }
}
